<template>
  <router-view v-if="!showTip"></router-view>
</template>

<script>
export default {
  name: 'AuditView',
  computed: {
    showTip() {
      return this.$root.state.facilityData.showTip;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AuditView.vue